The code of the action.

Currently, the following action codes are defined:

- `AgencySubmission`
- `CandidateWorkflowTransition`
- `Document`
- `Email`
- `Note`
- `PhoneCall`
- `PostPlacementActivity`
- `Screening`
- `StatusChange`
- `VerificationActivity`
- `Other`

For profile actions, one action code is defined:

- `ViewProfile` indicates that the URL is used to view the candidate's profile.
